const VALIDATE = {
  email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  password: /([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]){6,18}/,
  number: /^(-?\d+\.\d+)$|^(-?\d+)$/,
}

export default VALIDATE



// WEBPACK FOOTER //
// ./src/constants/validate.js